import React from 'react'
import {ListGroup} from 'react-bootstrap'

type Props<itemType> = {
  items: itemType[]
  keyExtractor: (itemType: itemType) => string
  labelExtractor: (itemType: itemType) => string
  onClickItem: (item: itemType) => void
  isSelectedItem: (item: itemType) => boolean
  getStyle: (item: itemType) => React.CSSProperties
}

const AppListItems = <itemType,>({
  items,
  getStyle,
  isSelectedItem,
  onClickItem,
  keyExtractor,
  labelExtractor,
}: Props<itemType>) => {
  return (
    <ListGroup>
      {items?.map((item, index) => (
        <ListGroup.Item
          title={labelExtractor(item)}
          className='text-truncate'
          key={keyExtractor(item)}
          onClick={() => onClickItem(item)}
          active={isSelectedItem(item)}
          style={getStyle(item)}
        >
          {labelExtractor(item)}
        </ListGroup.Item>
      ))}
    </ListGroup>
  )
}

export default AppListItems
